import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";

import EstudiantesTableCalif from './EstudiantesTableCalif';

import { ConsultaMisSecciones, EstPorSeccion, ConsultaCortes, UploadXls } from '../../funciones/CalifFunction';

class Calificaciones extends Component {
    state = {
        valorSeccion: { value: '', label: '- Selecciona una Seccion -' },
        secciones: [{
            value: '',
            label: ' - Cargando - ', codigo: '',
            carrera: '',
            semestre: '',
            seccion: ''
        }],

        valorCorte: { value: '', label: '- Selecciona un Corte -' },
        cortes: [{ value: '', label: ' - Cargando - ', codigo: '' }],
        preloaderCorte: "",
        estudiantes: [],
        boton1: {
            Icon: "fa fa-upload",
            Title: "Subir Archivo xls"
        },
        detalles: {
            class: "custom-alert-warning",
            title: <strong>Detalles de la Sección</strong>
        },
        estErr: [],
        btnDisabled: false,
        preloaderEst: "",
        literales:[]
    }

    constructor (props) {
        super (props);

        ConsultaMisSecciones ((resp) => {
            this.setState({
                secciones: resp[0],
                literales: resp[1],
            })
        })

        ConsultaCortes ((resp) => {
            this.setState({
                cortes: resp
            })
        })
    }

    valorSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            boton1: {
                Icon: "fa fa-upload",
                Title: "Subir Archivo xls"
            },
            btnDisabled: false,
            detalles: {
                class: "custom-alert-warning",
                title: <strong>Detalles de la Sección</strong>
            },
            estudiantes: [],
            preloaderEst: <React.Fragment><i className = "fa fa-spinner fa-spin"></i> Buscando Estudiantes</React.Fragment>,
        }, () => {
            if (this.state.valorCorte.value === "") return null;
            EstPorSeccion(valorSeccion.value, (resp) => {
                let prel = ""
                if (resp[0].length === 0) prel = "No existen estudiantes en esta sección"
                this.setState({
                    estudiantes: resp[0],
                    preloaderEst: prel
                })
            })
        })
    }

    valorCorte = (valorCorte) => {
        this.setState({
            preloaderCorte: "fa fa-spinner fa-spin",
            boton1: {
                Icon: "fa fa-upload",
                Title: "Subir Archivo xls"
            },
            detalles: {
                class: "custom-alert-warning",
                title: <strong>Detalles de la Sección</strong>
            },
            estudiantes: [],
            preloaderEst: <React.Fragment><i className = "fa fa-spinner fa-spin"></i> Buscando Estudiantes</React.Fragment>,
        }, () => {
            if (this.state.valorSeccion.value === ""){
                this.setState({
                    valorCorte,
                    preloaderCorte: ""
                })
            }else{
                EstPorSeccion(this.state.valorSeccion.value, (resp) => {
                    let prel = ""
                    if (resp[0].length === 0) prel = "No existen estudiantes en esta sección"
                    this.setState({
                        estudiantes: resp[0],
                        valorCorte,
                        preloaderCorte: "",
                        preloaderEst: prel
                    })
                })
            }
        })
    }

    selectFile = () => (e) => {
        if (this.state.btnDisabled === true) return null;
        document.getElementById("upXls").click();
    }

    uploadFile = () => (e) => {
        let { valorSeccion, valorCorte, btnDisabled } = this.state;

        if (btnDisabled === true) return null;

        let archivo = document.getElementById("upXls").value;
        let extension = archivo.split('.').pop();
        let ext = extension.toLowerCase();

        if (archivo === ""){ toast.error("No has seleccionado ningún archivo",{autoClose: 4000}); return null }
        if (ext !== "xls"){
            toast.error("No has seleccionado un archivo .xls",{autoClose: 4000});
            document.getElementById("upXls").value = "";
            return null
        }

        this.setState ({
            boton1: {
                Icon: "fa fa-spinner fa-spin",
                Title: "Subiendo el archivo",
            },
            btnDisabled: true
        }, () => {
            UploadXls(document.getElementById("upXls"), valorSeccion.value, valorCorte.value, (resp)=> {
                let data = JSON.parse(resp);
                let nameErrores = data.est;
                let contentErr = [];
                let ciErr = [];

                for (let i in nameErrores) {
                    if (nameErrores[i] !== "") contentErr.push(
                        <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i].est}</div>
                    )
                }

                for (let i in nameErrores) {
                    ciErr.push(nameErrores[i].estCi)
                }

                let erroresList = (
                    <Popover bsSize="large" title="Calificaciones No Agregadas" id="erroresList">
                        {contentErr}
                    </Popover>
                )

                if (data.errores > 0) {
                    this.setState({
                        detalles: {
                            class: "custom-alert-danger",
                            title:  <div>
                                        Se han encontrado {data.errores} error(es). Haz click <span>
                                        <OverlayTrigger trigger="focus" placement="bottom" overlay={erroresList}>
                                            <button style={{borderWidth: 1, backgroundColor:"#b41806", color: "#FFF"}} className="btn btn-danger btn-xs">Aqui</button> 
                                        </OverlayTrigger></span> para verlos
                                    </div>
                        },
                        estErr: ciErr,
                        btnDisabled: false,
                    })
                }else{
                    this.setState({
                        detalles: {
                            class: "custom-alert-warning",
                            title: <strong>Detalles de la Sección</strong>
                        }
                    })
                }
                
                EstPorSeccion(valorSeccion.value, (resp) => {
                    this.setState({
                        estudiantes: resp[0],
                        boton1: {
                            Icon: "fa fa-upload",
                            Title: "Subir Archivo xls"
                        },
                        btnDisabled: false,
                    }, () => {
                        toast[data.status](data.mess,{autoClose: 6000});
                        document.getElementById("upXls").value = "";
                    })
                })
                
            })
        })
    }

    contenido = () => {
        let { secciones, valorSeccion, cortes, valorCorte, estudiantes, preloaderCorte, literales } = this.state;

        const styles = {
            padding: 5, fontSize: 12
        }

        let estudiants = () => {
            let { estErr } = this.state;
            if (valorSeccion.value === "") {
                return (
                    <tr>
                        <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                            Selecciona una sección
                        </td>
                    </tr>
                )
            }else{
                if (valorCorte.value === "") {
                    return (
                        <tr>
                            <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                                Selecciona el Corte de Notas a cargar calificaciones
                            </td>
                        </tr>
                    )
                }else{
                    if(estudiantes.length === 0){
                        return (
                            <tr>
                                <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                                    {this.state.preloaderEst}
                                </td>
                            </tr>
                        )
                    }
    
                    let num = 1
                    let numero = () => { return num ++; }
    
                    let num2 = 1
                    let numero2 = () => { return num2 ++; }
    
                    return (
                        estudiantes.map(option => (
                            <EstudiantesTableCalif 
                                key={ `est_${numero2()}` }
                                num = { numero() }
                                est = { option }
                                corte = { valorCorte.value }
                                seccion = { valorSeccion.value }
                                estErr = { estErr }
                                literales = {literales}
                                modalidad = {valorSeccion.cuantitativo}
                                />
                        ))
                    )
                }
            }
        }

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        let noDown = (
            <Popover bsSize="large" title="No puedes realizar este proceso" id="Inscrito">
                <div className="custom-alert-danger">¿No puedes importar la calificacion?</div>
                <div className="custom-mt-10"><strong>Tal vez se deba a dos razones:</strong></div>
                <div className="custom-mt-10">
                    <Row>
                        <Col md={2} align="center"><strong>1</strong></Col>
                        <Col md={10} align="justify">
                            Es posible que la sección que seleccionaste no posea ningún estudiante inscrito
                        </Col>
                    </Row>
                </div>
                <div align="justify" className="custom-mt-10">
                    <Row>
                        <Col md={2} align="center"><strong>2</strong></Col>
                        <Col md={10} align="justify">
                            No has seleccionado el corte a importar
                        </Col>
                    </Row>
                </div>
            </Popover>
        )

        let boton = () => {
            let { boton1 } = this.state;
            if (this.state.estudiantes.length > 0){
                return(
                    <React.Fragment>
                        <button className="btn btn-success" onClick={this.selectFile()} style={{borderWidth:1, backgroundColor: "#4aa5a5", borderColor: "#4aa5a5", color:"#FFF"}} title="Importar calificaciones a partir de la hoja de cálculo generada por el sistema"><i className={boton1.Icon}></i> {boton1.Title}</button>
                        <input type="file" id="upXls" onChange= {this.uploadFile()} className="form-control" style={{ display: "none"}}/>
                    </React.Fragment>
                )
            }else{
                return(
                    <OverlayTrigger trigger="focus" placement="left" overlay={noDown}>
                        <button className="btn btn-success" style={{borderWidth:1, backgroundColor: "#4aa5a5", borderColor: "#4aa5a5", color:"#FFF"}} title="Importar calificaciones a partir de la hoja de cálculo generada por el sistema"><i className={boton1.Icon}></i> {boton1.Title}</button>
                    </OverlayTrigger>
                )
            }
        }

        let detalles = () => {
            let { detalles } = this.state;
            if (valorSeccion.value === "") return null;

            let corte = () => {
                if (valorCorte.value === "") return "No Seleccionado"
                return valorCorte.label;
            }
            return (
                <React.Fragment>
                    
                    <Row className="custom-mt-10">
                        <Col md={8}>
                            <div className={detalles.class} style={{paddingTop: 8, paddingBottom: 8, paddingLeft: 5, paddingRight: 5}}>
                                <span>{detalles.title}</span>
                            </div>  
                        </Col>
                        <Col md={4} align="right">
                            {boton()}
                        </Col>
                    </Row>
                    
                    <Row className="custom-mt-10">
                        <Col md={3} style={{fontSize:10}}>
                            <span className="text-danger">Carrera</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-danger">Semestre</span>
                        </Col>
                        <Col md={5} style={{fontSize:10}}>
                            <span className="text-danger">Sección</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-danger">Corte</span>
                        </Col>

                        <Col md={3} style={{fontSize:10}}>
                            <span className="text-muted">{valorSeccion.carrera}</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-muted">{valorSeccion.semestre}</span>
                        </Col>
                        <Col md={5} style={{fontSize:10}}>
                            <span className="text-muted">{valorSeccion.seccion}</span>
                        </Col>
                        <Col md={2} style={{fontSize:10}}>
                            <span className="text-muted">{corte()}</span>
                        </Col>
                    </Row>
                </React.Fragment>
            )
        }

        return(
            <React.Fragment>
                <div className="custom-alert-info" style={{padding:5}}>
                    <Row>
                        <Col md={7}>
                            <span>Selecciona una Sección</span>
                            <Select
                                styles={{menu: customStyles}}
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSeccion}
                                options={secciones}
                            />
                        </Col>
                        <Col md={5}>
                            <span>Selecciona un Corte <i className={preloaderCorte}></i></span>
                            <Select
                                isSearchable ={true}
                                value={valorCorte}
                                onChange={this.valorCorte}
                                options={cortes}
                            />
                        </Col>
                    </Row>
                </div>
                {detalles()}
                <div className="table-responsive custom-mt-10">
                    <Table striped hover bordered>
                        <tbody>
                            <tr className="custon-back-color">
                                <td width="70%" colSpan={3} style={styles}><strong>Estudiantes</strong></td>
                                <td width="30%" colSpan={2} style={styles} align= "center"><strong>Calificación</strong></td>
                            </tr>
                            {estudiants()}
                        </tbody>
                    </Table>
                </div>
            </React.Fragment>
        )
    }

    ayuda = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>Paso 1:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>Selecciona <strong>La Sección</strong> que deseas agregar calificaciones.</div>
                    </Col>

                    <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 2:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>Selecciona <strong>Un Corte</strong> que esté disponible.</div>
                    </Col>
                    <Col md={12} align="justify" className="custom-mt-10">
                        <div style={{fontSize:10}}><strong>Importante: La calificación del corte de notas debe hacerse en la escala correspondiente sin tomar en cuenta el porcentaje equivalente de dicho corte.</strong></div>
                        <div style={{fontSize:10}}><strong>Si la calificación corresponde del 1 al 20 se debe colocar la calificación obtenida. Por Ejemplo: 14</strong></div>
                    </Col>

                    <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 3:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>
                            Una vez seleccionados el corte y la sección, asegúrate que son los correctos mediante la opción <span className="custom-alert-warning"><strong>Detalles de la Sección</strong></span>
                        </div>
                    </Col>

                    <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 4:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>En este punto pordrás ver el listado de estudiantes correspondientes a la sección y en la parte derecha de cada estudiante un <strong>Cuadro de Texto</strong> donde podrás colocar la calificación.</div>
                    </Col>

                    <Col md={12} className="custom-mt-10">
                        <strong style={{color:"#1f2f6e"}}>Paso 5:</strong>
                    </Col>
                    <Col md={12} align="justify">
                        <div>Para cambiar la calificación simplemente haz click en el <strong>Cuadro de Texto</strong>, ingresa una calificación válida y espera que el icono de la derecha cambie de <i className="fa fa-circle-o-notch fa-spin"></i> a:</div>
                        <div><i className="fa fa-check" style={{color:"#32704C"}}></i>: Indica que la calificación se almacenó correctamente.</div>
                        <div><i className="fa fa-times" style={{color:"#A0555C"}}></i>: Indica que ocurrió un problema con la calificación, en este caso debes volver a ingresar una calificación válida.</div>
                        <div className="custom-mt-10"><strong>Tip:</strong> Para avanzar entre una calificación y otra presiona la tela Enter.</div>
                    </Col>
                </Row>
                <hr/>
                <Row>
                    <Col md={12}>
                        <strong style={{color:"#1f2f6e"}}>El botón</strong> <button className="btn btn-primary btn-xs" style={{borderWidth:1, backgroundColor: "#4aa5a5", borderColor: "#4aa5a5", color:"#FFF"}}><i className="fa fa-upload"></i> Subir Archivo xls</button>
                    </Col>

                    <Col md={12} align="justify" className="custom-mt-10">
                        <div>Permite adjuntar el archivo de calificaciones (proporcionado por el sistema) para cargar las calificaciones correspondientes a la materia y el corte seleccionados.</div>
                        <div className="custom-mt-10">Para eso simplemente haz <strong>click</strong> en el botón y selecciona el documento .xls que contiene las calificaciones de la sección.</div>
                        <div className="custom-mt-10">Luego de eso el sistema analizará las calificaciones y serán actualizadas <strong style={{color:"#1f2f6e"}}>automáticamente.</strong></div>
                        <div className="custom-mt-10">En caso de que alguna calificación no se actualice, el sistema te notificará indicando el o los estudiantes que tienen algún error.</div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    render() {
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        <div style={{borderRadius: "4px 4px"}}>
                            <CustomCard
                                title="Carga de Calificaciones"
                                category=""
                                color="#a80012"
                                content={this.contenido()}
                            />
                        </div>
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Carga de Calificaciones</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
 
export default Calificaciones;


// WEBPACK FOOTER //
// ./src/views/ProfAcademicos/Calificaciones.jsx